/**
 * Все шиммеры в одной фазе — по часам документа, а не с момента монтирования.
 *
 * Скелет страницы на время загрузки её кода и тот же скелет, который потом
 * рисует сама страница, — разные элементы: при подмене CSS-анимация
 * начиналась с нуля, и блик заметно прыгал назад, хотя разметка та же.
 * Здесь каждой новой анимации скелета ставится `startTime = 0`: она идёт так,
 * будто крутилась с загрузки страницы, и новый скелет подхватывает фазу
 * старого. Заодно все скелеты на экране пульсируют синхронно.
 *
 * Имена — keyframes Tailwind (`animate-pulse`, `Skeleton` из `shared/ui`) и
 * HeroUI (`animate-skeleton`, блик у его `Skeleton`).
 *
 * Правка идёт в `MutationObserver`: его колбэк — микрозадача, она успевает
 * до отрисовки кадра, и первый кадр нового скелета уже в нужной фазе.
 * `getAnimations()` при этом сам досчитывает стили, так что анимация у
 * только что вставленного элемента уже существует.
 */
const SHIMMER_ANIMATIONS = new Set(['pulse', 'skeleton']);
const SHIMMER_SELECTOR = '.animate-pulse, .skeleton';

export function syncSkeletonShimmer(): void {
  if (typeof document.getAnimations !== 'function') return;

  const observer = new MutationObserver((records) => {
    const added = records.some((record) =>
      Array.from(record.addedNodes).some(
        (node) =>
          node instanceof Element &&
          (node.matches(SHIMMER_SELECTOR) || node.querySelector(SHIMMER_SELECTOR) !== null),
      ),
    );
    if (!added) return;

    for (const animation of document.getAnimations()) {
      if (
        animation instanceof CSSAnimation &&
        SHIMMER_ANIMATIONS.has(animation.animationName) &&
        animation.startTime !== 0
      ) {
        animation.startTime = 0;
      }
    }
  });
  observer.observe(document.body, { childList: true, subtree: true });
}
